import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToolsModule } from '@huge-monorepo/shared/tools';
import { TableHeader } from '@huge-monorepo/shared/interfaces';
import { ActivatedRoute } from '@angular/router';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import { SharedTeltonikaSingletonService } from '@huge-monorepo/shared/services';
import { IHIPTeltonikaService, ICustomerTeltonikaService } from '@huge-monorepo/shared/interfaces';

@Component({
  selector: 'huge-monorepo-teltonika-device-auditing',
  standalone: true,
  imports: [CommonModule, ToolsModule, MaterialModule],
  templateUrl: './teltonika-device-auditing.component.html',
  styleUrl: './teltonika-device-auditing.component.scss',
})
export class TeltonikaDeviceAuditingComponent implements OnInit {
  teltonikaService = this.sharedTeltonikaService.getService();
  headers: TableHeader[] = [
    {
      ID: 'ID',
      Index: 1,
      Sort: 'ID',
      Sortable: false,
      Text: 'ID',
      Type: Number,
      Align: 'left',
      Width: 50,
    },
    {
      ID: 'Timestamp',
      Index: 2,
      Sort: 'Timestamp',
      Sortable: false,
      Text: 'Timestamp',
      Type: String,
      Align: 'left',
    },
    {
      ID: 'User',
      Index: 3,
      Sort: 'User',
      Sortable: false,
      Text: 'User',
      Type: String,
      Width: 100,
      Align: 'left',
    },
    {
      ID: 'Type',
      Index: 4,
      Sort: 'Type',
      Sortable: false,
      Text: 'Action Type',
      Type: String,
      Align: 'left',
    },
    {
      ID: 'Description',
      Index: 5,
      Sort: 'Description',
      Sortable: false,
      Text: 'Description',
      Type: String,
      Align: 'left',
    },


  ];

  data: any[] = [];
  isLoading: boolean = false;
  id: number;
  pageNumber: number = 1;
  allDeviceActionTypes: string[] = [
    "Delete Tag",
    "Reboot Device",
    "Update Tag",
    "Create Tag",
    "Update Device Tag",
    "Update Teltonika Custom Name",
    "Generate TS File",
    "Generate Backup File"
  ];

  constructor(
    private activatedRoute: ActivatedRoute, 
    private sharedTeltonikaService: SharedTeltonikaSingletonService<ICustomerTeltonikaService | IHIPTeltonikaService>,
  ) 
  { }

  ngOnInit(): void {
    this.isLoading = true;

    this.activatedRoute.paramMap.subscribe(
      (paraMap: any) => {
        if (paraMap.params.id) {
          this.id = paraMap.params.id;
          // Get the last 10 logs for the device. 
          // This needs to change to get the last 10 logs for the current page. Eg: 10 logs for page 1, the next 10 logs for page 2 (pages 11 -> 20) etc.
          this.teltonikaService.getDeviceLogs(paraMap.params.id, this.allDeviceActionTypes, 10).subscribe({

            next: (data) => {
              if (data == null) {
                this.isLoading = false;
                return;
              }

              // We don't worry if data is null here, we couldn't find anything then is the db for this device.
              // Set as null so that we display no Data found on FE.
              this.data = data;
              this.isLoading = false;
            },
            error: (error) => {
              console.error(error);
              this.isLoading = false;
            },

          });
        }
      }
    )
  }
}
